<template>
	<div class="contianer main-content">

		<div class="row">
			
			<div class="col-12 header-container text-center pb-2">
				<h2 class="lrg secondary-highlight">Order not complete.</h2>
			</div>

			<div class="col-12 col-sm-8 offset-sm-2 text-center">
				<img class="full-width shadow-bottom" src="./../assets/img/shadow_bottom.png" alt="shadow">
			</div>

		</div>
		
		<div class="row">
			<div class="offset-0 col-12 offset-sm-3 col-sm-6 pt-3 text-center info-text">
				<p v-if="$gstate.getFlowState().paymentMethod == 'BANKTRANSFER'">
					Unfortunately we were unable to complete your payment.<br />Please contact your financial institution and try again.
				</p>
			</div>
		</div>

		<div class="row">
			<div class="col-12 pt-4 text-center">
				<h4 class="dark-highlight"><strong>Summary</strong></h4>
			</div>
		</div>

		<div class="row">
			<div class="offset-0 col-12 col-sm-8 offset-sm-2 pt-4">
				<ul class="no-bullets pl-0 e-transfer-bullets">
					<li>Order Total: <strong class="dark-highlight">${{ pq.fiatAmount | num2decimal }} {{ pq.fiatCurrency }}</strong></li>
					<li>{{ pq.cryptoCurrency }} Amount: <strong class="dark-highlight">{{pq.cryptoAmount | num8decimal }} {{ pq.cryptoCurrency }}</strong></li>
					<li v-if="$gstate.getCryptoAddress()">Receiving Address: <strong class="dark-highlight"> {{ $gstate.getCryptoAddress() }} </strong></li>
				</ul>	
			</div>
		</div>

		<div v-if="$gstate.getFlowState().paymentMethod == 'BANKTRANSFER'" class="row panel-warning mt-4 mb-5 p-3">
			<div class="col-12 col-sm-1 text-center">
				<div class="exclamation" alt="Exclamation"></div>
			</div>
			<div class="col-12 col-sm-11 text-center text-warning">
				<p>
					Your bank account has not been charged.
				</p>
			</div>
		</div>

		<div class="row mt-4">
			<div class="col-12 text-center">
				<a href="#" id="payment-etransfer-success-next" class="btn next-btn" v-on:click.prevent="done">Try Again</a>
			</div>
		</div>
	</div>
</template>

<script>

import { eventBus } from './../main'

export default {
    data(){
        return {
            pq: this.$gstate.getFlowState(),
        }
	},
	mounted(){
		eventBus.$emit('logGTMTransactionEvent', "transactionComplete");
	},
	created(){
		this.$emit('setLeaveNotification', false);
		this.$emit('setRateHoldTimer', false);
	},
    methods: {
        done: function (){
            this.$emit('reset', false);
            this.$gstate.redirectHome();
        }
    }
}
</script>
